import { ENV } from '../../environment';

type Config = {
  appId: string;
};

const DevEnv: Config = {
  appId: 'c7z8e9a5',
};

const StagingEnv: Config = {
  appId: 'c7z8e9a5',
};

const ProdEnv: Config = {
  appId: 'wyevgjz2',
};

export const config: Config = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
